import { Box, Flex, Text } from '@modusign/design-system';

import { ContextMenuRow } from '@app/components/ContextMenu';
import orderRotationForColor from '@app/libs/participantFields/orderRotationForColor';

interface ContextMenuRowParticipantNameProps {
  participantName?: string;
  participantOrder: number;
}

export default function ContextMenuRowParticipantName({
  participantName,
  participantOrder,
}: ContextMenuRowParticipantNameProps) {
  if (!participantName) return null;

  return (
    <ContextMenuRow>
      <Flex flexDirection="column" gap={4}>
        <Flex alignItems="center" gap={3}>
          <Box
            backgroundColor={`participantOrder${orderRotationForColor(participantOrder)}`}
            borderRadius="3px"
            height="18px"
            minHeight="19px"
            minWidth="19px"
            mr={3}
            textAlign="center"
          >
            <Text fontSize="xs" fontWeight="medium">
              {participantOrder}
            </Text>
          </Box>
          <Text fontWeight="medium">{participantName}</Text>
        </Flex>
      </Flex>
    </ContextMenuRow>
  );
}
